<style lang="scss" scoped>
</style>


<template>
  <div class="field">
    <label v-if="label" class="label">{{label}}</label>
    <div class="control">
      <!-- :class="{'is-danger': hasError}" -->
      <input
        class="input"
        :type="type"
        :placeholder="placeholder"
        :autocomplete="autocomplete"
        :value="value" @input="$emit('input', $event.target.value)">
    </div>
    <p v-for="error in errors" :key="error" class="help is-danger">
      {{error}}
    </p>
  </div>
</template>


<script>
import { isEmpty } from 'lodash';


export default {
  name: 'text-input',
  props: {
    value: null,
    label: String,
    placeholder: String,
    error: null,
    autocomplete: null,
    type: {
      type: String,
      default: 'text'
    }
  },
  computed: {
    errors() {
      if (this.error == null || this.error == undefined) {
        return [];
      }
      return Array.isArray(this.error) ? this.error : [this.error];
    },
    hasError() {
      return !isEmpty(this.errors);
    }
  }
};
</script>
